<mat-icon svgIcon="timelineCursor" [style.margin-left]="left$ | async">
</mat-icon>
